
import { Component, Vue, Prop } from 'vue-property-decorator'
import { controlLoop } from '@/components/helpers/utils'
import TimelineControls from '@/components/TimelineControls.vue'
import Timeline from '@/components/Timeline.vue'

@Component({ components: { Timeline, TimelineControls } })
export default class ImagenesSatelitalesFooter extends Vue {
  @Prop() timelineList!: string[]
  @Prop() currentPosition!: number

  private nieveImage: string = 'https://pronosticos.alertaaire.cl/sensores/nieve_colorbarHorizontal_w.png'
  private precipitacionImage: string = 'https://pronosticos.alertaaire.cl/sensores/PrecipitacionIMERG_colorbarHorizontal_w.png'
  private incendioImage: string = 'https://pronosticos.alertaaire.cl/sensores/IncendioFIRMS_colorbarHorizontal_w.png'

  private control!: any

  created () {
    this.control = controlLoop(() => {
      this.$emit('timeSelected', { position: this.nextPosition })
    })
  }

  destroyed () {
    this.control.destroy()
  }

  timeSelected (event: MouseEvent) {
    this.control.pause()
    this.$emit('timeSelected', event)
  }

  get nextPosition () {
    const len = this.timelineList.length
    if (this.currentPosition < (len - 1)) {
      return this.currentPosition + 1
    }
    return 0
  }

  get previousPosition () {
    if (this.currentPosition > 0) {
      return this.currentPosition - 1
    }
    return this.timelineList.length - 1
  }

  get computedImage () {
    if (this.$route.query.type) {
      const type = this.$route.query.type.toString()
      switch (type) {
        case 'PrecipitacionIMERG':
          return this.precipitacionImage
        case 'NieveMODIS':
          return this.nieveImage
        case 'IncendioFIRMS':
          return this.incendioImage
      }
    }
    return ''
  }

  next () {
    this.control.pause()
    this.$emit('timeSelected', { position: this.nextPosition })
  }

  previous () {
    this.control.pause()
    this.$emit('timeSelected', { position: this.previousPosition })
  }

  paused () {
    this.control.pause()
  }

  played () {
    this.control.play()
  }
}
